import type {ProductListItemData} from '../../types';

import {Badge} from '@ds/components';
import bestSellerBadge from 'assets/images/best-seller-badge.png';
import promotionIcon from 'assets/images/promotion-center/promotion-icon-primary-color.svg';
import {numberFormat} from 'utils/Helper';

import {PRODUCT_BADGE_LABELS, TOP_SELLER_VENDOR_BADGE} from '../../constants';

type ProductListItemProps = {
  item: ProductListItemData;
};

const ProductListItem: React.FC<ProductListItemProps> = ({item}) => {
  const stock = numberFormat(item.stock ?? 0);
  const hasDiscount = item.vendor_share > 0;
  const finalPrice = item.price * (hasDiscount ? (100 - item.vendor_share) / 100 : 1);
  const isBestSeller = item.badges?.includes(TOP_SELLER_VENDOR_BADGE);

  return (
    <article className="flex w-full gap-4 border-b border-gray-03 px-4 py-2">
      <div className="flex shrink-0 flex-col items-center gap-2">
        <div className="relative flex size-20 items-center justify-center rounded-lg bg-gray-02 p-1">
          <img
            src={item.image}
            alt={item.title ?? ''}
            className="size-full object-contain mix-blend-multiply"
          />
          {isBestSeller && (
            <img
              src={bestSellerBadge}
              alt=""
              aria-hidden
              className="absolute -end-0.5 -top-0.5 size-6"
            />
          )}
        </div>
        <span className="rounded-full bg-gray-02 px-2 py-0.5 text-caption-sm text-destructive">
          مانده: {stock}
        </span>
      </div>

      <div className="min-w-0 flex-1">
        <p className="my-1.5 text-body-sm text-gray-09">{item.title}</p>
        <p className="my-1.5 text-body-sm text-gray-09">بارکد: {item.barcode}</p>
        <div className="flex flex-col">
          <p className="text-body-md text-gray-09">
            {numberFormat(finalPrice)} <span className="text-body-xs text-gray-07">تومان</span>
          </p>
          <div className="flex flex-wrap items-center gap-2">
            {hasDiscount && (
              <>
                <span className="text-body-xs text-gray-07 line-through decoration-orange">
                  {numberFormat(item.price)}
                </span>
                <Badge variant="count" color="primary" size="md" count={`${item.vendor_share}%`} />
              </>
            )}
            {item.commercial_share && (
              <Badge variant="status" color="primary" size="sm" className="gap-1">
                <img src={promotionIcon} alt="" aria-hidden className="size-4" />
                کمپین
              </Badge>
            )}
          </div>
        </div>
        <div className="my-2 flex flex-wrap gap-1">
          {item.badges?.map((badge) => {
            if (badge === 'UNSPECIFIED') {
              return null;
            }
            return (
              <Badge key={badge} variant="status" color="neutral" size="md">
                {PRODUCT_BADGE_LABELS[badge] ?? badge}
              </Badge>
            );
          })}
        </div>
      </div>
    </article>
  );
};

export default ProductListItem;
